import AUTH_TOKEN from '../constants/authToken'

/* Envio dos formulários de cadastro (médico, paciente, instituição).

   Os três repetiam o mesmo bloco de fetch + tratamento de erro, e o mesmo
   detalhe fácil de errar: `FormData` converte tudo em texto, então um campo
   `undefined` vira a string "undefined" e o servidor grava isso. */

export function paraFormData(objeto) {
  return Object.keys(objeto).reduce((form, chave) => {
    const valor = objeto[chave]

    if (valor === undefined || valor === null) return form

    // Lista de vínculos (planos, especialidades, clínicas): vai como "1,2,3",
    // e vazia vira "" — que a API entende como "nenhum", de propósito, porque
    // é assim que se desmarca o último item.
    if (Array.isArray(valor)) {
      form.append(chave, valor.join(','))
      return form
    }

    form.append(chave, valor)
    return form
  }, new FormData())
}

/**
 * Envia o formulário e devolve `true` se salvou.
 *
 * Em caso de erro escreve a mensagem da API no topo do modal (via
 * `actions.setStatus`) em vez de deixar o usuário no escuro — foi assim que a
 * regra de CRM duplicado ficou visível na tela.
 */
export async function enviarCadastro({ url, method = 'PUT', values, actions }) {
  try {
    const resposta = await fetch(url, {
      method,
      body: paraFormData(values),
      headers: { Authorization: `Bearer ${localStorage.getItem(AUTH_TOKEN)}` }
    })
    const retorno = await resposta.json().catch(() => null)

    if (!resposta.ok) {
      actions.setStatus(
        (retorno && (retorno.detail || retorno.message)) ||
        'Não foi possível salvar. Revise os campos e tente de novo.'
      )
      actions.setSubmitting(false)
      return false
    }

    actions.setSubmitting(false)
    return true
  } catch (e) {
    actions.setStatus('Falha de conexão. Tente de novo.')
    actions.setSubmitting(false)
    console.error(e)
    return false
  }
}
